import { createRouteMetrics } from '@spotify-internal/next-router-metrics';
import {
  createSemanticMetrics,
  createUniversalReporter,
} from '@spotify-internal/semantic-metrics';

const { sendMetric } = createSemanticMetrics({
  key: 'atlas-web',
  reporter: createUniversalReporter(),
  // uncomment if the key is not the same as your component_id
  // component_id: 'atlas-web',
});

const withRouteMetrics = createRouteMetrics(sendMetric);

export { sendMetric, withRouteMetrics };
